<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
            <template v-slot:activator="{ on, attrs }">
                <!--<v-btn icon :color="actionColor" v-bind="attrs" v-on="on">
                    <v-icon dense medium>{{actionIcon}}</v-icon>
                </v-btn>-->

                <v-btn class="ma-0 darkgray--text" small v-bind="attrs" v-on="on">
                    {{caption}}
                    <v-icon right dark :color="actionColor">
                        {{actionIcon}}
                    </v-icon>
                </v-btn>
            </template>
            <v-card height="100%">
                <v-form ref="form"
                        v-model="valid"
                        lazy-validation>
                    <v-card-title>
                        <span class="headline">Favourites List</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form ref="form" v-model="valid">
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field v-model="listItem.listName" label="List Name *" :counter="64" :rules="rules.name" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-checkbox v-model="listItem.isDefault" label="Is Default" :disabled="true" required></v-checkbox>
                                    </v-col>
                                    <v-col>
                                        <span style="color:red">{{errorMessage}}</span>
                                        <span style="color:saddlebrown">{{infoMessage}}</span>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                        <small>* indicates required field</small>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialog = false;">Close</v-btn>
                        <v-btn color="blue darken-1" text @click="save();" :disabled="!canDelete" :loading="loading">{{action}}</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import appsettings from '../../appsettings.js';
    import axios from "axios";
    export default {
        data: () => ({
            dialog: false,
            errorMessage: "",
            infoMessage:"",
            isDelete: false,
            canDelete: true,
            isDefault: false,
            newlistItem: {},
            listItem: {
                id: 0,
                originId: '',
                xId: 0,
                listName: "",
                locationDepartmentId: 0,
                isDefault: false
            },
            rules: {
                name: [
                    v => !!v || 'Name is required',
                    v => (v && v.length >= 3) || 'Name must be at least 3 characters',
                    v => (v && v.length <= 64) || 'Name must be less than 64 characters'
                ],
            },
            valid: true,
            loading: false,
        }),
        props: {
            favoritesList: {},
            actionIcon: {},
            actionColor: {},
            action: {},
            onDataUpdate: {},
            caption: {}
        },
        watch: {
            dialog: function (newVal, oldVal) {
                this.reset();
                this.resetValidation();
            },
            favoritesList: function (newVal, oldVal) {
              
                Object.assign(this.listItem, this.favoritesList);
                this.canDelete = true;

                this.errorMessage = "";

                if (this.action.toUpperCase() == "DELETE" && this.favoritesList.isDefault) {
                    this.errorMessage = "You cannot delete your default favorites list. Please create another default list prior to deleting this one.";
                    this.isDelete = true;
                    this.canDelete = false;
                }

                if (this.action.toUpperCase() == "SAVE" && this.favoritesList.isDefault) {
                    this.infoMessage = "Note: You cannot change the 'default list' status of this list. To specify a different default list select that list and set it as the default.";
                }

                this.isDefault = this.listItem.isDefault;
            }
        },
        async mounted() {
            Object.assign(this.newlistItem, this.listItem)
            if (this.action.toUpperCase() == "CREATE") {
                this.listItem.locationDepartmentId = this.$route.params.locationDepartmentId;
            }
        },
        methods: {
            ...mapActions(["sendMessage"]),
            async save() {
                if (this.valid) {


                    let locationDepartmentId = this.$route.params.locationDepartmentId;

                    let item = {
                        ...this.listItem,
                    };

                    let routeFavoroitesList = `/api/MaterialFavoriteList`;
                    let result=null;
                    let method = 'POST';

                    if (this.listItem.id > 0) {
                      result = await axios.patch(routeFavoroitesList, item);
                    } else if (this.action.toUpperCase() === "DELETE") {
                      result = await axios.delete(routeFavoroitesList, item);
                    }
                    else {
                      result = await axios.post(routeFavoroitesList, item);
                    }

                    this.onDataUpdate(result, this.action.toUpperCase());
        
                    this.submitting = false;
                    this.dialog = false;

                }
            },
            validate() {
                if (this.$refs.form)
                {
                    this.$refs.form.validate();
                }
            },
            reset() {

      
                Object.assign(this.listItem, this.favoritesList );

                if (this.$refs.form) {
                    this.$refs.form.reset();
                }
            },
            resetValidation() {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
                
            }
        },
        computed: {
            locationDepartmentId() { return this.$root.$children[0].selectedDepartment; },
            ...mapGetters(['getVrsUser'])
        }
    }
</script>